<template>
  <article class="gh-list-item">
    <GenerationHistoryListItemHead
      :service-name-key="serviceNameKey"
      :project-name="item.project_name"
      :datetime="item.request_datetime_ts"
    />
    <div class="gh-list-item__body gh-list-item__body--half">
      <div class="gh-list-item__left">
        <div class="gh-list-item__preview">
          <template v-if="previewImages.length">
            <div class="gh-list-item__preview-images-wrap">
              <div class="gh-list-item__preview-images">
                <img
                  v-for="(image, idx) in previewImages"
                  :key="`${item.project_id}-img-${idx}`"
                  :src="imageUrl(image)"
                  class="gh-list-item__preview-image"
                  :class="{ 'gh-dnd-source': canDrag }"
                  alt=""
                  :draggable="canDrag ? 'true' : 'false'"
                  @dragstart="onPosterDragStart($event, image, idx)"
                  @dragend="onDragEnd"
                >
              </div>
              <div
                v-if="outputBody"
                class="gh-list-item__preview-output gh-card-text__field-value--output"
              >
                <span class="gh-prompt-popover__text">{{outputBody}}</span>
              </div>
            </div>
          </template>
          <p v-else class="gh-list-item__preview-text">{{ previewText }}</p>
        </div>
        <button
          type="button"
          class="gh-list-item__view-all"
          @click="$emit('view-all', item.project_id)"
        >
          {{ $t(viewAllKey, { count: item.total_count }) }}
        </button>
      </div>
      <div class="gh-list-item__right">
        <GenerationHistoryMetaRows
          :fields="inlineFields"
          variant="inline"
          :row-key-prefix="`concept-${item.project_id}`"
        />
      </div>
    </div>
  </article>
</template>

<script>
import {
  getListInlineMetaFields,
  getListLeftPreview,
  getServiceNameKey,
  getViewAllLinkKey,
} from '@/shared/helpers/generationHistory';
import { GH_DRAG_SOURCE } from '@/shared/helpers/generationHistoryDrag';
import { generationHistoryCardDragMixin } from '@/shared/mixins/generationHistoryDragDropMixin';
import GenerationHistoryListItemHead from '../shared/GenerationHistoryListItemHead.vue';
import GenerationHistoryMetaRows from '../shared/GenerationHistoryMetaRows.vue';

export default {
  name: 'GenerationHistoryListItemConcept',
  mixins: [generationHistoryCardDragMixin],
  components: {
    GenerationHistoryListItemHead,
    GenerationHistoryMetaRows,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    serviceNameKey() {
      return getServiceNameKey(this.item.project_type);
    },
    viewAllKey() {
      return getViewAllLinkKey(this.item.project_type);
    },
    preview() {
      return getListLeftPreview(this.item, this.item.project_type);
    },
    previewImages() {
      return this.preview.mode === 'image' ? (this.preview.images || []) : [];
    },
    previewText() {
      return this.preview.mode === 'text' ? this.preview.text : '';
    },
    outputBody() {
      return this.preview.text || '';
    },
    inlineFields() {
      return getListInlineMetaFields(this.item, (key) => this.$t(key));
    },
  },
  methods: {
    imageUrl(image) {
      if (!image) {
        return '';
      }
      if (typeof image === 'string') {
        return image;
      }
      return image.url || '';
    },
    onPosterDragStart(event, image, idx) {
      const url = this.imageUrl(image);
      const itemId = typeof image === 'object' && image ? image.itemId : null;
      const itemType = typeof image === 'object' && image ? image.itemType : null;
      const posterIndex = typeof image === 'object' && image && image.posterIndex != null
        ? image.posterIndex
        : idx;
      this.startGhImageDrag(event, {
        url,
        itemId,
        itemType,
        posterIndex: posterIndex || 0,
        sourceType: GH_DRAG_SOURCE.CONCEPT,
      });
    },
  },
};
</script>
